import {Device, DeviceField, DeviceFlat} from ".";
import {FirmwareField} from "../firmware";
import {OrganizationField} from "../organization";

export function convertDeviceToDeviceFlat(device: Device): DeviceFlat {
    const {currentFirmware, targetFirmware, organization, ...rest} = device;
    return {
        ...rest,
        [DeviceField.CURRENT_FIRMWARE_ID]: currentFirmware?.[FirmwareField.ID],
        [DeviceField.CURRENT_FIRMWARE_VERSION_NUMBER]: currentFirmware?.[FirmwareField.VERSION_NUMBER],
        [DeviceField.CURRENT_FIRMWARE_LEGACY]: currentFirmware?.[FirmwareField.LEGACY],
        [DeviceField.ORGANIZATION_ID]: organization?.[OrganizationField.ID],
        [DeviceField.ORGANIZATION_NAME]: organization?.[OrganizationField.NAME],
        [DeviceField.ORGANIZATION_CUSTOMER_NUMBER]: organization?.[OrganizationField.MAIN_DKV_CUSTOMER_NUMBER],
        [DeviceField.TARGET_FIRMWARE_ID]: targetFirmware?.[FirmwareField.ID],
        [DeviceField.TARGET_FIRMWARE_VERSION_NUMBER]: targetFirmware?.[FirmwareField.VERSION_NUMBER],
        [DeviceField.TARGET_FIRMWARE_LEGACY]: targetFirmware?.[FirmwareField.LEGACY],
    };
}
